import { useState } from 'react';
import { AnimatePresence, motion as Motion } from 'motion/react';
import { ArrowUpRight, Menu, Moon, Sun, X } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { useActiveSection } from '../../hooks/useActiveSection';

const sectionIds = ['about', 'work', 'experience', 'contact'];

// The responsive header combines navigation, locale selection and theme controls.
export function Header() {
  const { language, setLanguage, theme, toggleTheme, t } = useApp();
  const [menuOpen, setMenuOpen] = useState(false);
  const activeSection = useActiveSection(sectionIds);
  const navigation = sectionIds.map((id) => ({ id, label: t.nav[id] }));

  function closeMenu() {
    setMenuOpen(false);
  }

  return (
    <>
      <header className="site-header">
        <a className="brand-mark" href="#top" aria-label="Afshin Zehtab — home">
          <img className="brand-logo brand-logo--light" src="/images/logo-back-on-white.png" alt="" />
          <img className="brand-logo brand-logo--dark" src="/images/logo-primary.png" alt="" />
        </a>

        <nav className="desktop-nav" aria-label="Primary navigation">
          {navigation.map((item) => (
            <a className={activeSection === item.id ? 'is-active' : ''} href={`#${item.id}`} key={item.id}>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="header-actions">
          <div className="language-switch" aria-label="Language selection">
            {['en', 'de', 'fa'].map((locale) => (
              <button
                className={language === locale ? 'is-active' : ''}
                type="button"
                onClick={() => setLanguage(locale)}
                key={locale}
                aria-pressed={language === locale}
              >
                {locale.toUpperCase()}
              </button>
            ))}
          </div>
          <button className="icon-button" type="button" onClick={toggleTheme} aria-label={t.actions.theme}>
            {theme === 'dark' ? <Sun size={17} /> : <Moon size={17} />}
          </button>
          <button className="icon-button mobile-menu-button" type="button" onClick={() => setMenuOpen(true)} aria-label={t.actions.menu}>
            <Menu size={19} />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {menuOpen && (
          <Motion.div
            className="mobile-menu"
            initial={{ opacity: 0, clipPath: 'circle(0% at 92% 8%)' }}
            animate={{ opacity: 1, clipPath: 'circle(145% at 92% 8%)' }}
            exit={{ opacity: 0, clipPath: 'circle(0% at 92% 8%)' }}
            transition={{ duration: 0.55, ease: [0.76, 0, 0.24, 1] }}
          >
            <div className="mobile-menu__top">
              <span className="brand-mark brand-mark--inverse">
                <img className="brand-logo" src="/images/logo-primary.png" alt="Afshin Zehtab" />
              </span>
              <button className="icon-button icon-button--inverse" type="button" onClick={closeMenu} aria-label={t.actions.close}>
                <X size={20} />
              </button>
            </div>
            <nav aria-label="Mobile navigation">
              {navigation.map((item, index) => (
                <a href={`#${item.id}`} onClick={closeMenu} key={item.id}>
                  <small>0{index + 1}</small><span>{item.label}</span><ArrowUpRight />
                </a>
              ))}
            </nav>
            <p>Munich · 48.1351° N / 11.5820° E</p>
          </Motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
